import { render, staticRenderFns } from "./couponDetailManage.vue?vue&type=template&id=22e08737&scoped=true"
import script from "./couponDetailManage.vue?vue&type=script&lang=js"
export * from "./couponDetailManage.vue?vue&type=script&lang=js"
import style0 from "./couponDetailManage.vue?vue&type=style&index=0&id=22e08737&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e08737",
  null
  
)

export default component.exports